<template>
  <div class="public-show" v-if="flag">
    <div class="show-mask" @click="close"></div>
    <img class="show-main" :src="url" :alt="name" @error="close" />
  </div>
</template>
<script>
export default {
  name: 'PublicShowImg',
  data() {
    return {
      flag: false,
      url: '',
      name: ''
    }
  },
  methods: {
    show(url, name) {
      if (!url) return
      const img = document.c
      this.url = url
      this.name = name
      this.flag = true
    },
    close() {
      this.flag = false
    }
  }
}
</script>
<style lang='scss' scoped>
.public-show {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100001;
  .show-mask {
    width: 100%;
    height: 100%;
    // background: rgba($color: #fff, $alpha: 0.5);
    position: relative;
    z-index: 10;
    cursor: pointer;
  }
  .show-main {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}
</style>
